import { takeLatest, call, put } from "redux-saga/effects";

import * as types from "../actions/actionTypes";
import { DownloadFileAction, InitAction } from "../actions";
import * as DownloadFileApi from "../api/downloadFile";
import { toastr } from "react-redux-toastr";
import checkErrorMessagesExist from "../assets/checkErrorMessagesExist";
import { SetMessage } from "../assets/errorMessages";

export function* watcherDownloadFile() {
  yield takeLatest(types.DOWNLOAD_FILE_REPORT_REQUEST, file);
  yield takeLatest(types.DOWNLOAD_FILE_CHECK_FILES_REQUEST, checkFiles);
}

function askFile(data) {
  return DownloadFileApi.askFile(data);
}

function* file(action) {
  try {
    const response = yield call(askFile, action.data);
    yield put(DownloadFileAction.reportSuccess(response.data.data));
    yield put(DownloadFileAction.checkFilesRequest());
    if (response.data.premium) {
      yield put(
        InitAction.getSuccess({ updatePremium: response.data.premium })
      );
    }
  } catch (error) {
    SetMessage(error, true);
    yield put(DownloadFileAction.reportFailure());
  }
}

function checkFilesReq() {
  return DownloadFileApi.checkFiles();
}

function* checkFiles() {
  try {
    const response = yield call(checkFilesReq);
    yield put(DownloadFileAction.checkFilesSuccess(response.data.data));
    yield put(InitAction.getSuccess({ updatePremium: response.data.premium }));
  } catch (error) {}
}
